exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* light blue */\n\n/* Specific course colors */\n", ""]);

// exports
exports.locals = {
	"dark90": "rgba(0, 0, 0, 0.9)",
	"dark70": "rgba(0, 0, 0, 0.7)",
	"dark60": "rgba(0, 0, 0, 0.6)",
	"dark50": "rgba(0, 0, 0, 0.5)",
	"dark40": "rgba(0, 0, 0, 0.4)",
	"dark30": "rgba(0, 0, 0, 0.3)",
	"dark20": "rgba(0, 0, 0, 0.2)",
	"dark10": "rgba(0, 0, 0, 0.1)",
	"lightGrey": "#eee",
	"dark5": "rgba(0, 0, 0, 0.05)",
	"dark3": "rgba(0, 0, 0, 0.03)",
	"light": "rgba(255, 255, 255, 1)",
	"oneRgb": "80, 155, 238",
	"one": "rgba(80, 155, 238, 1)",
	"oneDark": "rgba(75, 146, 223, 1)",
	"one10": "rgba(80, 155, 238, 0.1)",
	"one15": "rgba(80, 155, 238, 0.15)",
	"one15full": "#DCEBFC",
	"one20": "rgba(80, 155, 238, 0.2)",
	"one30": "rgba(80, 155, 238, 0.3)",
	"one40": "rgba(80, 155, 238, 0.4)",
	"one60": "rgba(80, 155, 238, 0.6)",
	"one80": "rgba(80, 155, 238, 0.8)",
	"twoRgb": "255, 133, 51",
	"two": "rgba(255, 133, 51, 1)",
	"two10": "rgba(255, 133, 51, 0.1)",
	"two15": "rgba(255, 133, 51, 0.15)",
	"two20": "rgba(255, 133, 51, 0.2)",
	"two30": "rgba(255, 133, 51, 0.3)",
	"two40": "rgba(255, 133, 51, 0.4)",
	"two80": "rgba(255, 133, 51, 0.8)",
	"threeRgb": "255, 215, 38",
	"three": "rgba(255, 215, 38, 1)",
	"three10": "rgba(255, 215, 38, 0.1)",
	"three20": "rgba(255, 215, 38, 0.2)",
	"three30": "rgba(255, 215, 38, 0.3)",
	"three80": "rgba(255, 215, 38, 0.8)",
	"fourRgb": "255, 192, 218",
	"four": "rgba(255, 192, 218, 1)",
	"fiveRgb": "118, 234, 118",
	"five": "rgba(118, 234, 118, 1)",
	"sixRgb": "246, 65, 65",
	"six": "rgba(246, 65, 65, 1)",
	"sevenRgb": "163, 159, 223",
	"seven": "rgba(163, 159, 223, 1)",
	"eightRgb": "226, 167, 212",
	"eight": "rgba(226, 167, 212, 1)",
	"nineRgb": "255, 201, 148",
	"nine": "rgba(255, 201, 148, 1)",
	"ten": "#14b8dc",
	"white": "rgb(255,255,255)",
	"white90": "rgba(255,255,255, 0.9)",
	"white80": "rgba(255,255,255, 0.8)",
	"white70": "rgba(255,255,255, 0.7)",
	"white60": "rgba(255,255,255, 0.6)",
	"white50": "rgba(255,255,255, 0.5)",
	"white40": "rgba(255,255,255, 0.4)",
	"white20": "rgba(255,255,255, 0.2)",
	"medium": "#5cffa0",
	"resources": "rgb(226, 167, 212)",
	"facebook": "#3b5998",
	"htmlCssCourse": "rgba(255, 133, 51, 1)",
	"jsCourse": "#f9e579"
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader?modules&importLoaders=1!./~/postcss-loader!./src/style/color.css
 ** module id = 2
 ** module chunks = 0
 **/